import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@99designs/common/components/Icon';
import { DesignerLevel } from 'apps/find-designers/propTypes';
import LevelPill from 'components/Designers/LevelPill';

const DesignerBrandingExtras = ({ level, isContact }) => {
    function contactIcon() {
        if (!isContact) return null;

        return (
            <span className="designer-branding-extras__relationship">
                <Icon type={'contacts-1'} />
            </span>
        );
    }

    return (
        <div className="designer-branding-extras">
            <span className="designer-branding-extras__level">
                <LevelPill level={level} />
            </span>
            {contactIcon()}
        </div>
    );
};

DesignerBrandingExtras.propTypes = {
    level: DesignerLevel.isRequired,
    isContact: PropTypes.bool.isRequired,
};

export default DesignerBrandingExtras;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignerBrandingExtras.jsx